module.exports = __webpack_public_path__ + "static/img/IMG_20240807_224342.b1329ccc.jpg";